import { Group, Text } from '@mantine/core';
import { Icons } from './Icons';
export type InputValidateErrorProps = {
  notification: string;
};
export const InputValidateError: React.FC<InputValidateErrorProps> = ({
  notification
}) => {
  return <Group component="span" gap={8}>
      <Icons className="icon-pr-line-info" fontSize={16} />
      <Text span fz="xs">
        {notification}
      </Text>
    </Group>;
};